import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    root: {
      backgroundColor: "#fff",
      borderRadius: 3,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      boxShadow: "0px 1px 7px 0 rgba(0,0,0,0.1)"
    },
    header: {
      height: 42,
      padding: "0 16px",
      borderBottom: `1px solid ${primary.light}`,
      display: "flex",
      alignItems: "center",
      fontSize: 16
    },
    emptyNotepad: {
      height: 122,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    addButton: {
      color: primary.dark,
      fontSize: 16,
      textTransform: "capitalize",
      "& .MuiButton-label": {
        flexDirection: "column",
        alignItems: "center"
      },
      "& .MuiButton-startIcon": {
        marginRight: 0
      }
    },
    addIcon: {
      "&.MuiSvgIcon-root": {
        fontSize: 27
      }
    },
    editMode: {
      padding: "24px 16px 32px"
    },
    notepadTextarea: {
      "& label.MuiFormLabel-root": {
        fontSize: 14
      },
      "& .MuiInputBase-root": {
        borderRadius: 3,
        color: primary.main,
        paddingBottom: 22
      },
      "& .MuiInputBase-input": {
        maxHeight: 136,
        overflowY: "auto !important"
      },
      "& .Mui-focused fieldset": {
        borderWidth: 1
      }
    },
    buttons: {
      marginTop: 28,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    button: {
      fontSize: 16,
      color: primary.dark,
      height: 32,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    saveButton: {
      color: secondary.dark,
      marginLeft: 22
    },
    editButton: {
      marginTop: 20,
      color: secondary.dark,
      display: "flex",
      alignSelf: "flex-end",
      width: 64
    },
    existedComment: {
      padding: "20px 16px 22px",
      display: "flex",
      flexDirection: "column"
    },
    existedCommentContent: {
      wordBreak: "break-all",
      whiteSpace: "pre-line"
    },
    warningText: {
      display: "block"
    },
    loader: {
      height: 122
    }
  };
});
